import React, { ReactNode, FC } from 'react';
import { withProps } from 'recompose';
import { UserType } from 'api/models/core-types';
import { ControlBasedOnUserType } from './components';

const withCustomer = withProps({ userType: UserType.External });
const withVendor = withProps({ userType: UserType.Native });
const withPartner = withProps({ userType: UserType.Partner });
const withShow = withProps({ controlType: 'show' });
const withHide = withProps({ controlType: 'hide' });

export const ShowForCustomer = withCustomer(withShow(ControlBasedOnUserType));
export const ShowForVendor = withVendor(withShow(ControlBasedOnUserType));
export const HideForCustomer = withCustomer(withHide(ControlBasedOnUserType));
export const HideForVendor = withVendor(withHide(ControlBasedOnUserType));
export const ShowForPartner = withPartner(withShow(ControlBasedOnUserType));
export const HideForPartner = withPartner(withHide(ControlBasedOnUserType));

interface SwitchProps {
  forCustomer: ReactNode;
  forVendor: ReactNode;
}

export const SwitchBetweenCustomerAndVendor: FC<SwitchProps> = ({
  forCustomer,
  forVendor,
}) => (
  <>
    <ShowForCustomer>{forCustomer}</ShowForCustomer>
    <ShowForVendor>{forVendor}</ShowForVendor>
  </>
);
